import { n as normalizeComponent } from "../chunks/_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const _sfc_main = {
  name: "NcAppContentList",
  props: {
    /**
     * Is the list selected
     */
    selection: {
      type: Boolean,
      default: false
    },
    /**
     * Is the details pane shown
     */
    showDetails: {
      type: Boolean,
      default: false
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "app-content-list", class: { selection: _vm.selection, showdetails: _vm.showDetails } }, [_vm._t("default")], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const NcAppContentList = __component__.exports;
export {
  NcAppContentList as default
};
//# sourceMappingURL=NcAppContentList.mjs.map
